import { FC } from "react";
import { IconProps } from "./types";

export const ProfileIcon: FC<IconProps> = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    {...props}
  >
    <g id="profile">
      <g id="vector">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4.7998C14.6509 4.7998 16.7997 6.94873 16.7998 9.59961C16.7998 12.2506 14.651 14.3994 12 14.3994C9.34912 14.3993 7.2002 12.2505 7.2002 9.59961C7.2003 6.9488 9.34919 4.79991 12 4.7998ZM12 5.7998C9.90147 5.79991 8.2003 7.50108 8.2002 9.59961C8.2002 11.6982 9.90141 13.3993 12 13.3994C14.0987 13.3994 15.7998 11.6983 15.7998 9.59961C15.7997 7.50102 14.0986 5.7998 12 5.7998Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM8 17.2998C7.17157 17.2998 6.5 17.9714 6.5 18.7998V21.5234C8.11844 22.4601 9.99553 23 12 23C14.0045 23 15.8816 22.4601 17.5 21.5234V18.7998C17.5 17.9714 16.8284 17.2998 16 17.2998H8ZM12 1C5.92487 1 1 5.92487 1 12C1 15.6429 2.77222 18.8702 5.5 20.8721V18.7998C5.5 17.4191 6.61929 16.2998 8 16.2998H16C17.3807 16.2998 18.5 17.4191 18.5 18.7998V20.8721C21.2278 18.8702 23 15.6429 23 12C23 5.92487 18.0751 1 12 1Z"
        />
      </g>
    </g>
  </svg>
);
